import { flexRender, Table } from '@tanstack/react-table'
import { THead, THeadCell, TRowHeader } from '@tecsinapse/cortex-react'
import React from 'react'

interface HeaderProps<T> {
  table: Table<T>
}

export const HeaderColumns = <T,>({ table }: HeaderProps<T>) => {
  return (
    <THead>
      {table.getHeaderGroups().map(headerGroup => (
        <TRowHeader key={headerGroup.id}>
          {headerGroup.headers.map(header => (
            <THeadCell
              key={header.id}
              colSpan={undefined}
              style={
                header.getSize() === 20 ? { padding: 0, width: 65 } : undefined
              }
            >
              {flexRender(header.column.columnDef.header, header.getContext())}
            </THeadCell>
          ))}
        </TRowHeader>
      ))}
    </THead>
  )
}
